<template>
  <div class="doctor-list-page">
    <van-notice-bar
      left-icon="volume-o"
      text="预约前务必仔细阅读预约须知，按时就诊"
      color="#1989fa"
      background="#ecf5ff"
    />

    <div class="loading-container" v-if="authorizing">
      <van-loading size="24px">正在授权登录...</van-loading>
    </div>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else>
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
        <div v-if="list.length === 0 && !loading" class="empty">
          <van-icon name="user-o" size="60" color="#ddd" />
          <p>暂无医生排班</p>
        </div>

        <van-cell-group class="doctor-list" v-for="item in list" :key="item.doctorId">
          <van-cell class="doctor-item" clickable @click="goDetail(item)">
            <div slot="title" class="doctor-header">
              <div class="doctor-avatar">
                <img :src="getAvatarUrl(item.avatar)" :alt="item.doctorName" />
              </div>
              <div class="doctor-info">
                <div class="doctor-name">
                  <span class="name">{{ item.doctorName }}</span>
                  <span class="title">{{ item.title }}</span>
                  <van-tag plain color="#3e97c1" round class="has-num">有号</van-tag>
                </div>
                <div class="doctor-tags" v-if="item.tags">
                  <van-tag v-for="(tag, index) in parseTags(item.tags)" :key="index" color="#3e97c1" text-color="#fff" size="large">{{ tag }}</van-tag>
                </div>
                <div class="doctor-desc">
                  {{ item.specialty || '暂无擅长领域介绍' }}
                </div>
              </div>
            </div>
          </van-cell>
        </van-cell-group>
      </van-list>
    </van-pull-refresh>

    <div style="height: 70px;"></div>
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o" to="/index/index">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/yuyue/index">预约</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'YuyueIndex',
  data() {
    return {
      active: 1,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      authorizing: true,
      defaultAvatar: ''
    }
  },
  created() {
    // 首先检查是否有code参数
    var code = this.$tool.getUrlParamByName('code');
    if (code) {
      // 有code，直接进行授权
      this.handleWechatLogin(code);
    } else {
      // 没有code，检查授权是否过期
      if (this.$tool.isAuthorized()) {
        this.authorizing = false;
        // 移除这里的 loadData() 调用，让 van-list 组件自动触发
      } else {
        // 授权过期，检查是否已登录
        if (this.$tool.isLoggedIn()) {
          // 已登录但授权过期，直接使用本地存储的用户信息
          this.authorizing = false;
        } else {
          // 未登录，进行微信授权
          this.goWechatAuthorize();
        }
      }
    }
  },
  methods: {
    checkWechatCallback() {
      var code = this.$tool.getUrlParamByName('code');
      if (code) {
        this.handleWechatLogin(code);
      } else {
        this.goWechatAuthorize();
      }
    },
    goWechatAuthorize() {
      var appId = 'wxae49507c8c332234';
      var redirectUri = encodeURIComponent(window.location.origin + window.location.pathname + '#/yuyue/index');
      var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appId
              + '&redirect_uri=' + redirectUri
              + '&response_type=code&scope=snsapi_userinfo&state=patient#wechat_redirect';
      window.location.href = url;
    },
    handleWechatLogin(code) {
      this.authorizing = true;
      this.$http.get(this.$Api.wechatAuthorize, {
        params: { code: code }
      }).then(res => {
        this.authorizing = false;
        if (res.data.code === 200) {
          var data = res.data.data;
          // 添加授权时间戳
          data.authorizeTime = new Date().toISOString();
          this.$tool.setUser({
            userId: data.userId,
            openid: data.openid,
            isBind: data.isBind,
            realName: data.realName,
            phone: data.phone,
            idCard: data.idCard,
            nickname: data.nickname,
            headimgurl: data.headimgurl,
            authorizeTime: data.authorizeTime
          });
          // 清除URL中的code参数
          this.$tool.clearUrlParams();
          // 设置loading为true，防止van-list自动触发loadData
          this.loading = true;
          this.loadData();
        } else {
          // 清除缓存并重新授权
          this.$tool.removeUser();
          this.$toast.fail(res.data.msg || '登录失败');
          setTimeout(() => {
            this.goWechatAuthorize();
          }, 1000);
        }
      }).catch(() => {
        this.authorizing = false;
        this.$toast.fail('网络错误');
      });
    },
    onChange(index) {
      console.log('切换到索引：', index);
    },
    loadData() {
      this.$http.get(this.$Api.doctorList)
        .then(res => {
          this.loading = false;
          this.refreshing = false;
          if (res.data.code === 200) {
            this.list = res.data.data || [];
            this.finished = true;
          } else {
            this.$toast.fail(res.data.msg || '获取失败');
          }
        })
        .catch(() => {
          this.loading = false;
          this.refreshing = false;
          this.$toast.fail('网络错误');
        });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.loadData();
    },
    parseTags(tags) {
      if (!tags) return [];
      try {
        return JSON.parse(tags);
      } catch (e) {
        return tags.split(',');
      }
    },
    getAvatarUrl(avatar) {
      if (!avatar) return this.defaultAvatar;
      // 检查是否已经是完整URL
      if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
        return avatar;
      }
      // 否则使用当前域名拼接完整URL
      return window.location.origin + avatar;
    },
    goDetail(doctor) {
      this.$router.push('/yuyue/detail?doctorId=' + doctor.doctorId);
    }
  }
}
</script>

<style scoped>
.van-tabbar-item--active {
  color: #3e97c1;
}
.doctor-list-page {
  background-color: #f7f8fa;
  min-height: 100vh;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}
.empty {
  text-align: center;
  padding: 60px 0;
  color: #999;
}
.empty p {
  margin-top: 16px;
}
.doctor-list {
  border-radius: 8px;
  overflow: hidden;
  margin: 10px;
}
.doctor-item {
  padding: 12px 16px;
  background: #fff;
  border-radius: 8px;
}
.doctor-header {
  display: flex;
  align-items: flex-start;
}
.doctor-avatar {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
}
.doctor-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.doctor-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.doctor-name {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.doctor-name .name {
  font-size: 18px;
  font-weight: bold;
  color: #323233;
  margin-right: 8px;
}
.doctor-name .title {
  font-size: 14px;
  color: #969799;
  margin-right: auto;
}
.doctor-name .has-num {
  font-size: 12px;
  padding: 3px 10px;
}
.doctor-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.doctor-desc {
  font-size: 14px;
  color: #646566;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/yuyue/index.vue